export enum RelativeDirection {
	left = 'left',
	down = 'down',
	up = 'up',
	right = 'right',
}
